
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Volvosleeperbus() {



    const cardData =
    {
        keyword: 'Volvo Sleeper Bus on Rent in Pune',
        heading: 'Amruta Travels: Volvo Sleeper Bus on Rent in Pune',
        headingDescription: 'Amruta Travels offers Volvo Sleeper Bus on Rent in Pune, providing a luxurious and comfortable transportation solution for your long-distance travel needs. Whether you are planning an overnight journey, corporate retreat, family vacation, or group tour, our well-maintained Volvo sleeper buses ensure a smooth and restful experience. Equipped with air-conditioned interiors, spacious sleeper berths, and ample luggage space, our buses are designed for maximum comfort and reliability. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your overnight travel from Pune simple and stress-free.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

     "services": [
    {
      "name": "Outstation Bus Rental Pune",
      "description": "Amruta Travels offers reliable outstation bus rental services from Pune to various destinations, including Mumbai, Goa, Hyderabad, and South India. Our fleet includes 25-50 seater AC buses, ensuring comfort and convenience for your journey."
    },
    {
      "name": "AC Bus for Long Trips from Pune",
      "description": "Travel in comfort with our AC buses for long trips from Pune. Whether it's a corporate tour, family function, or pilgrimage, our buses are equipped with modern amenities to make your journey pleasant."
    },
    {
      "name": "25-50 Seater Bus Hire Pune to Outstation",
      "description": "Choose from our range of 25-50 seater buses for outstation trips from Pune. Ideal for group travel, our buses provide ample space and comfort for your journey to destinations like Nashik, Shirdi, and more."
    },
    {
      "name": "Pune to Mumbai/Goa/Hyderabad Bus Hire",
      "description": "Book our buses for travel from Pune to Mumbai, Goa, or Hyderabad. We offer both AC and non-AC options, with flexible packages to suit your travel needs."
    },
    {
      "name": "Corporate Tour Bus Pune Outstation",
      "description": "Plan your corporate tours with our specialized bus services. Our buses are equipped with amenities to ensure a comfortable and productive journey for your team."
    },
    {
      "name": "Family Function Bus Outstation",
      "description": "Celebrate family functions like weddings, reunions, or anniversaries with our outstation bus services. We provide comfortable and safe travel options for your family gatherings."
    },
    {
      "name": "Volvo Coach Outstation Pune",
      "description": "Experience luxury travel with our Volvo coaches for outstation trips from Pune. These buses offer premium comfort, making your journey enjoyable and relaxing."
    },
    {
      "name": "Group Tour Outstation Bus Hire",
      "description": "Organize group tours with our outstation bus hire services. We cater to various group sizes and destinations, ensuring a seamless travel experience."
    },
    {
      "name": "Wedding Bus for Outstation Pune",
      "description": "Arrange transportation for wedding guests with our outstation bus services from Pune. We provide timely and comfortable travel options for your special day."
    },
    {
      "name": "Bharat Benz Outstation Trip Bus",
      "description": "Travel in style with our Bharat Benz buses for outstation trips from Pune. These buses offer superior comfort and are perfect for long-distance journeys."
    },
    {
      "name": "Pune to South India Bus Service",
      "description": "Embark on a journey to South India with our bus services from Pune. We offer customized packages to destinations like Bangalore, Chennai, and Hyderabad."
    },
    {
      "name": "Pilgrimage Bus Outstation Pune",
      "description": "Visit religious sites with our pilgrimage bus services from Pune. We provide comfortable and safe travel options to destinations like Shirdi, Nashik, and more."
    },
    {
      "name": "Long-Distance AC Bus Hire",
      "description": "Opt for our long-distance AC bus hire services for extended trips. Our buses are equipped with modern amenities to ensure a comfortable journey."
    },
    {
      "name": "Pune Event Tour Outstation Bus",
      "description": "Attend events with our outstation bus services from Pune. We provide transportation for conferences, exhibitions, and other events, ensuring timely arrivals."
    },
    {
      "name": "Weekend Trip Bus Rental",
      "description": "Plan your weekend getaways with our bus rental services. We offer trips to nearby destinations like Lonavala, Mahabaleshwar, and Alibaug."
    }
  ],
  "tableData": [
    ["Outstation Bus Rental Pune", "AC Bus for Long Trips from Pune"],
    ["25-50 Seater Bus Hire Pune to Outstation", "Pune to Mumbai/Goa/Hyderabad Bus Hire"],
    ["Corporate Tour Bus Pune Outstation", "Family Function Bus Outstation"],
    ["Volvo Coach Outstation Pune", "Group Tour Outstation Bus Hire"],
    ["Wedding Bus for Outstation Pune", "Bharat Benz Outstation Trip Bus"],
    ["Pune to South India Bus Service", "Pilgrimage Bus Outstation Pune"],
    ["Long-Distance AC Bus Hire", "Pune Event Tour Outstation Bus"],
    ["Weekend Trip Bus Rental"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Volvo Sleeper Bus on Rent in Pune",
    "WhyChoosedescription": "Amruta Travels offers top-tier Volvo Sleeper buses on rent in Pune, ideal for long-distance and overnight travel. With unmatched comfort, safety, and reliability, our Volvo sleeper buses are perfect for group tours, corporate trips, and pilgrimage journeys across India."
  },
  {
    "WhyChooseheading": "Ultimate Comfort with Sleeper Berths and AC",
    "WhyChoosedescription": "Our Volvo sleeper buses are equipped with spacious sleeper berths, fully air-conditioned interiors, and modern suspension systems. Passengers can relax and rest comfortably during overnight journeys, making long trips feel short and relaxing."
  },
  {
    "WhyChooseheading": "Perfect for Outstation and Interstate Group Travel",
    "WhyChoosedescription": "Whether you're planning a trip to Goa, Bangalore, Shirdi, Hyderabad, or any other destination, our Volvo sleeper buses are designed for smooth, long-distance travel. They’re ideal for family tours, religious yatras, company outings, and educational trips."
  },
  {
    "WhyChooseheading": "Luxurious Interiors with Modern Amenities",
    "WhyChoosedescription": "Our sleeper coaches feature plush bedding, charging points, reading lights, curtains for privacy, and clean onboard washrooms (select models). Travel in style and convenience, no matter the destination or group size."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe Overnight Travel",
    "WhyChoosedescription": "All our Volvo sleeper buses are operated by professional and experienced drivers trained for long-distance and overnight routes. They ensure a safe, punctual, and smooth journey from Pune to your destination."
  },
  {
    "WhyChooseheading": "Transparent and All-Inclusive Pricing",
    "WhyChoosedescription": "We offer competitive rental rates with no hidden fees. Our pricing includes fuel, tolls, driver charges, and taxes, giving you peace of mind while planning your group travel expenses."
  },
  {
    "WhyChooseheading": "Custom Travel Plans to Suit Your Itinerary",
    "WhyChoosedescription": "Amruta Travels provides fully customizable Volvo sleeper bus rental plans based on your trip schedule. Choose your pickup and drop locations, timing, and route—our team will ensure everything runs smoothly and on time."
  },
  {
    "WhyChooseheading": "24/7 Booking Support and Travel Assistance",
    "WhyChoosedescription": "Our customer support team is available 24/7 to assist with bookings, route planning, changes in travel plans, and emergency support. Booking a Volvo sleeper bus in Pune has never been easier or more reliable."
  }
]





























    }

const faqData = [
  {
    question: 'Can I rent a Volvo sleeper bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers premium Volvo sleeper buses for rent in Pune. These buses are ideal for long-distance travel, providing ultimate comfort with spacious sleeper berths and modern amenities.',
  },
  {
    question: 'What amenities are available in the Volvo sleeper bus?',
    answer: 'Our Volvo sleeper buses are equipped with air conditioning, individual sleeper berths, reading lights, charging points, clean bedding, curtains for privacy, luggage space, entertainment systems, and a smooth air-suspension ride.',
  },
  {
    question: 'Is the Volvo sleeper bus suitable for both local and outstation travel?',
    answer: 'While primarily designed for long-distance and overnight journeys, Volvo sleeper buses can also be rented for local use if required. They’re best suited for intercity and interstate trips like Pune to Goa, Bangalore, Hyderabad, and more.',
  },
  {
    question: 'Is a driver included with the Volvo sleeper bus rental?',
    answer: 'Yes, all Volvo sleeper bus rentals from Amruta Travels include a licensed and experienced driver who is well-versed in long-distance travel and ensures a safe and timely journey.',
  },
  {
    question: 'What is the cost to rent a Volvo sleeper bus in Pune?',
    answer: 'The rental cost for a Volvo sleeper bus depends on factors like distance, duration, and travel route. Prices generally start from ₹45–₹60 per km. For a custom quote, please contact us with your travel itinerary.',
  },
  {
    question: 'Is the Volvo sleeper bus comfortable for overnight travel?',
    answer: 'Absolutely. The Volvo sleeper bus is designed for overnight travel with full-sleeper berths, air suspension, and climate control. It offers a restful experience, especially for long routes and overnight tours.',
  },
  {
    question: 'Are the Volvo sleeper buses sanitized and maintained regularly?',
    answer: 'Yes. At Amruta Travels, all Volvo buses are routinely inspected, cleaned, and sanitized before every journey to ensure hygiene and safety for all passengers.',
  },
  {
    question: 'How can I book a Volvo sleeper bus in Pune?',
    answer: 'You can book a Volvo sleeper bus by visiting our website or contacting our customer support. We provide fast booking, clear pricing, and end-to-end travel coordination for your convenience.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ramesh Shinde',
    role: 'Pilgrimage Group Leader, Pune',
    text: 'We booked a Volvo sleeper bus from Amruta Travels for our group trip to Tirupati. The bus was clean, the berths were comfortable, and we had a smooth overnight journey. Very professional service!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Jyoti Kale',
    role: 'Tour Operator',
    text: 'I arranged a Pune to Hyderabad trip for my clients using Amruta Travels’ Volvo sleeper bus. The passengers were extremely happy with the comfort and convenience. Highly recommend their services.',
    rating: 5,
  },
];



































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Volvo Sleeper Bus on Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/volvo-sleeper-bus-rental-pune.jpg",
  "description": "Amruta Travels offers Volvo Sleeper Bus on Rent in Pune for long-distance travel, night journeys, weddings, corporate events, and family tours. Book luxury sleeper coaches for comfortable overnight trips to destinations like Goa, Bangalore, Hyderabad, and more. Our AC sleeper buses provide safe, private, and spacious group travel across India.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "32000",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/volvo-sleeper-bus-rent-pune"
  }
};







    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Volvo Sleeper Bus on Rent in Pune | AC Sleeper Coach for Outstation Travel</title>
  <meta 
    name="description" 
    content="Hire a Volvo Sleeper Bus in Pune for weddings, corporate travel, group tours, and long-distance night journeys. Book AC sleeper coaches for destinations like Goa, Bangalore, Hyderabad, and more with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/62.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Volvosleeperbus;